import { render, staticRenderFns } from "./form-edit-tags.vue?vue&type=template&id=cf9e52dc&"
import script from "./form-edit-tags.vue?vue&type=script&lang=js&"
export * from "./form-edit-tags.vue?vue&type=script&lang=js&"
import style0 from "./form-edit-tags.vue?vue&type=style&index=0&id=cf9e52dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports